import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { IoTType } from '@frontend/iot/types';
import React from 'react';

import { useIoTTypeSelect } from './iot-type-select.controller';

const ID = 'iot-type-select';
export const IoTTypeSelect = (props: Omit<SelectInputV2Props<IoTType>, 'options'>) => {
    const { options, isLoading } = useIoTTypeSelect();

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            className={props.className}
            options={options}
            value={props.value}
            label={props.label || 'IoT type'}
            required={props.required}
            onSelect={(value) => props.onSelect && props.onSelect(value as { label: string; value: string })}
            isLoading={isLoading}
        />
    );
};
